// JavaScript Document

  function animateBurger(event){
    // $(".burgerMenue").toggleClass("active");
    // $(".wrapperLowerPart").toggleClass("openMenue");
    if(!isDesktop){
      $(".burgerMenue").toggleClass("active");
      $(".wrapperLowerPart").toggleClass("openMenue");
      // $("#header, .allContent").addClass('headerBig');
        event.preventDefault();

    }else{
      $(".burgerMenue").toggleClass("active");
      $(".wrapperLowerPart").toggleClass("openMenue");
      $("#header, .allContent").addClass('headerBig');

    }
  }

  function addAccordion(){

    $('.vi-uf-menueBoxInnerContent').append('<div class="accordion"></div>');

    var newParent = $('.accordion');
    var oldParent = $('.vi-uf-menueBoxInnerContent');

    newParent.append('<div class="accordion_content"></div>');
    oldParent.each(function(element){

      oldChildren = oldParent[element].children;
      accordionDiv = oldChildren[oldChildren.length-1]
      accordionContentdiv = accordionDiv.children[0];
      accordionDiv.prepend(oldChildren[0]);

      i = oldChildren.length-2;

      while(i >= 0){
        accordionContentdiv.prepend(oldChildren[i]);
        i--;
      }

    });
  }

  function enableAccordion(){
    $( ".accordion" ).accordion({
      header: ".vi-uf-menueBoxInnerTitle",
      content: ".vi-uf-menueMain",
      active: false,
      collapsible: true
    });
  }

  function openMenueSection(_id, _elem) {
    if(isDesktop) {
      $('.vi-uf-menueBoxInner').hide();
      var posY = $(_elem).position().left;
      $('.vi-uf-menueBoxInner').css({'left':'unset'})
      $('#' + _id).css({'position':'relative','left':posY});
      $('#' + _id).show();
      var menHeight = $('#' + _id).innerHeight();
      $('.wrapperLowerPart').css({'height': menHeight});
      $('.wrapperLowerPart').off('mouseleave').on('mouseleave', function () {
        $('#' + _id).hide();
          $('.vi-uf-menueBoxInner').css({'left':'unset'})
        $('.wrapperLowerPart').css({'height': '0'});
      });
      $('.headTop, .searchBox').off('mouseover').on('mouseover', function () {
        $('#' + _id).hide();
          $('.vi-uf-menueBoxInner').css({'left':'unset'})
          $('.wrapperLowerPart').css({'height': '0'});
      });
    }else{
      $('.wrapperLowerPart').css({'height': ''});
    }
  }

  function openSearchMobile() {
    $('.searchBox').toggleClass('active');

  }